import React, { Fragment, useState, useEffect, useContext } from 'react'
import { Link } from 'react-router-dom'
import Pagination from "react-js-pagination";
import AppContext from '../../contexts/AppContext'
import Breadcrumbs from '../Breadcrumbs'
import Header from '../Header'
import Footer from '../Footer'
import { breadcrumbsBy, locationSearchCity } from '../../services/locations'
import { searchProperty, searchFromHash, setEncoded, getEncoded } from '../../services/search'
import { numberFormat } from '../../services/posts'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSpinner } from '@fortawesome/free-solid-svg-icons'
import useToastContext from "../../hooks/useToastContext";

import moment from "moment"

import { Helmet } from "react-helmet-async";


const PointsTransactions = ({ match, history }) => {

    const { data, pointServices } = useContext(AppContext)
    const { app, isReady } = data
    const { user } = app

    const [ loading, setLoading ] = useState(false)
    const [ deleting, setDeleting ] = useState(null)
    const [ updating, setUpdating ] = useState(null)
    const [ search, setSearch ] = useState({})
    const [ points, setPoints ] = useState({})
    const [ searchActive, setSearchActive ] = useState(false)

    const addToast = useToastContext()

    const loadPoints = () => {
        return new Promise((resolve, reject) => {
            setLoading(true)
            setSearch(searchFromHash())
            pointServices.list(getEncoded()).then(res => {
                setPoints(res.points)
                setLoading(false)
                resolve()
            }).catch(res => {
                const message = res?.data?.message ? res.data.message : 'Something went wrong'
                addToast({ type: 'danger', title: 'Error', message: message })
                reject()
            })
        })
    }

    useEffect(() => {
        if(isReady) loadPoints()
    }, [ history.location.hash, isReady ])

    const setSearchProperty = (type, value) => {
        const res = searchProperty(search, type, value)
        setSearch(res.search)
        if(!res.isEqual) setSearchActive(true)
        return res.search
    }

    const onSearch = newSearch => {
        setEncoded(newSearch ? newSearch : {... search})
    }

    const changePage = page => {
        setEncoded(setSearchProperty('page', page == 1 ? null : page))
    }

    const title = "Credits and Points Transactions / Cash Transactions / Income for your sign ups / etc."

    return (
        <Fragment>
            <div className="d-flex justify-content-between mt-3">
                <div className="d-flex">
                    <h1 className="h4 mt-1">{title}</h1>
                    <div className="ms-3">
                        {/* --- */}
                    </div>
                </div>

                {points.data && points.data.length > 0 && points.last_page > 1 &&
                    <nav>
                        <Pagination
                            activePage={search.page}
                            itemsCountPerPage={parseInt(points.per_page)}
                            totalItemsCount={points.total}
                            pageRangeDisplayed={5}
                            onChange={changePage}
                            itemClass="page-item"
                            linkClass="page-link"
                            prevPageText="Previous"
                            nextPageText="Next"
                            hideFirstLastPages={true}
                        />
                    </nav>
                }
            </div>

            {loading && <FontAwesomeIcon icon={faSpinner} />}

            {!loading && points.data && points.data.length == 0 &&
                <p className="lead">
                    There are no transactions here yet.
                </p>
            }

            {!loading && points.data && points.data.length > 0 &&
                <Fragment>
                    <div className="table-responsive">
                        <table className="table table-striped table-bordered bg-white">
                            <thead>
                                <tr>
                                    <th className="text-center">#</th>
                                    <th className="text-center">Amount</th>
                                    <th className="text-left">Reason</th>
                                    <th className="text-center">Status</th>
                                    <th className="text-center">Date</th>
                                </tr>
                            </thead>
                            <tbody>
                                {points.data.map(item => {
                                    const isActive = item.active > 0
                                    return (
                                        <tr
                                            key={item.id}
                                            className={isActive ? '' : 'table-secondary'}
                                        >
                                            <td className="text-center">{item.id}</td>
                                            <td className="text-center">
                                                {isActive && <span className="text-muted font-weight-bold">{numberFormat(item.amount / 100)} Credits</span>}
                                                {!isActive && '–'}
                                            </td>
                                            <td className="text-left">
                                                {item.event && ['App\\Banner', 'App\\Promo', 'App\\User', 'App\\Post'].includes(item.event.eventable_type) &&
                                                    <span>
                                                        {['banner-purchase'].includes(item.type) && item.event.eventable &&
                                                            <span>Banner Purchased: <Link tag="a" to={'/account/banner/view/' + item.event.eventable_id}>#{item.event.eventable.id}</Link></span>
                                                        }
                                                        {['banner-refund'].includes(item.type) && item.event.eventable &&
                                                            <span>Banner Refunded: <Link tag="a" to={'/account/banner/view/' + item.event.eventable_id}>#{item.event.eventable.id}</Link></span>
                                                        }
                                                        {['post-purchase'].includes(item.type) && item.event.eventable &&
                                                            <span>Post Purchased: <a href={'/p/' + item.event.eventable.post_id}>{item.event.eventable.title}</a></span>
                                                        }
                                                        {['post-refund'].includes(item.type) && item.event.eventable &&
                                                            <span>Post Refunded: <a href={'/p/' + item.event.eventable.post_id}>{item.event.eventable.title}</a></span>
                                                        }
                                                        {['points-given'].includes(item.type) && item.event.meta &&
                                                            <span>Credits given: <b>{numberFormat(item.event.meta.points / 100)}</b>. {item.event.meta.message}</span>
                                                        }
                                                        {['promo-purchase'].includes(item.type) && item.event.eventable?.post &&
                                                            <span>Promo <a href={item.event.eventable.post.url}>{item.event.eventable.post.title}</a> for post Purchased</span>
                                                        }
                                                        {['promo-refund'].includes(item.type) && item.event.eventable &&
                                                            <span>Promo <a href={item.event.eventable.post.url}>{item.event.eventable.post.title}</a> for post Refunded</span>
                                                        }
                                                    </span>
                                                }
                                                {item.event?.eventable_type == 'App\\Post' &&
                                                    <span>
                                                        {item.type == 'user-post' && 'You created a post'}
                                                        {item.type == 'affiliate-post' && 'Your affiliate user created a post'}
                                                    </span>
                                                }
                                                {item.event?.eventable_type == 'App\\Pivots\\Affiliate' &&
                                                    <span>
                                                        For a user you signed up
                                                    </span>
                                                }
                                                {item.event && ['App\\Transaction'].includes(item.event.eventable_type) &&
                                                    <span>
                                                        {['points-bought'].includes(item.type) &&
                                                            <>
                                                                <span>Credits Purchased. Transaction #{item.event.eventable_id}. </span>
                                                                {item.event.eventable?.payment_method_details?.type == 'card' &&
                                                                    <span>
                                                                        <span className="text-capitalize me-1">Card: {item.event.eventable.payment_method_details.card.brand}</span>
                                                                        <span>ending {item.event.eventable.payment_method_details.card.last4}</span>
                                                                    </span>
                                                                }
                                                            </>
                                                        }
                                                    </span>
                                                }
                                            </td>
                                            <td className="text-center">{item.active ? 'Active' : 'Processing'}</td>
                                            <td className="text-center">{moment(item.created_at).format('MM/DD/YYYY hh:mm a')}</td>
                                        </tr>
                                    )
                                })}
                            </tbody>
                        </table>
                    </div>

                    {points.data && points.data.length > 0 && points.last_page > 1 &&
                        <nav>
                            <Pagination
                                activePage={search.page}
                                itemsCountPerPage={parseInt(points.per_page)}
                                totalItemsCount={points.total}
                                pageRangeDisplayed={5}
                                onChange={changePage}
                                itemClass="page-item"
                                linkClass="page-link"
                                prevPageText="Previous"
                                nextPageText="Next"
                                hideFirstLastPages={true}
                            />
                        </nav>
                    }
                </Fragment>
            }

        </Fragment>
    )
}

const PointsSummary = ({ }) => {

    const { data, pointServices } = useContext(AppContext)
    const { app, isReady } = data

    const [ loading, setLoading ] = useState(false)
    const [ summary, setSummary ] = useState(null)

    const loadSummary = () => {
        return new Promise((resolve, reject) => {
            setLoading(true)
            pointServices.summary().then(res => {
                setSummary(res.summary)
                setLoading(false)
                resolve()
            }).catch(res => {
                if(res.status == 404) history.push("/page-not-found")
                if(res.status == 500) history.push("/server-error")
                reject()
            })
        })
    }

    useEffect(() => {
        if(isReady) loadSummary()
    }, [ isReady ])

    return (
        <div className="card h-100">
            <div className="card-header d-flex flex-row justify-content-between">
                <h5 className="card-title mb-0">Summary</h5>
                <h5 className="card-title mb-0">1 credit = 100 points</h5>
            </div>
            {summary &&
                <table className="table table-bordered table-striped table-hover mb-0 mt-0">
                    <thead>
                        <tr>
                            <th>Item</th>
                            <th className="text-center">Credits</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>Income for your posts</td>
                            <td className="text-center">{numberFormat(summary.user_post_points / 100)}</td>
                        </tr>
                        <tr>
                            <td>Income for your sign ups</td>
                            <td className="text-center">{numberFormat(summary.affiliate_user_points / 100)}</td>
                        </tr>
                        <tr>
                            <td>Income for your sign up's posts</td>
                            <td className="text-center">{numberFormat(summary.affiliate_post_points / 100)}</td>
                        </tr>
                        <tr>
                            <td>Your purchases of credits/points</td>
                            <td className="text-center">{summary.purchase_points ? numberFormat(summary.purchase_points / 100) : '–'}</td>
                        </tr>
                        <tr>
                            <td>Expenses for banners / text line ads</td>
                            <td className="text-center">{numberFormat(summary.banner_expense / 100)}</td>
                        </tr>
                        <tr>
                            <td>Expenses for posts / links</td>
                            <td className="text-center">{numberFormat(summary.post_expense / 100)}</td>
                        </tr>
                        <tr>
                            <th className="h2">Total balance</th>
                            <td className="h2 text-center">{numberFormat(summary.points / 100)}</td>
                        </tr>
                    </tbody>
                </table>
            }
            {loading &&
                <div className="card-body m-5 text-center">
                    <FontAwesomeIcon icon={faSpinner} spin />
                </div>
            }
        </div>
    )

}

const CreditsAndPoints = ({ match, history }) => {

    const { data } = useContext(AppContext)
    const { app } = data
    const { location, user } = app

    const title = "Finance"

    return (
        <Fragment>
            <div>
                <Header history={history} />
                <main className="py-4">
                    <div className="container">

                        <Breadcrumbs list={breadcrumbsBy(location, [{url: '/account', title: 'Dashboard'}, {title}])} />

                        <Helmet><title>{title + ' | ' + process.env.MIX_APP_NAME}</title></Helmet>

                        <div className="d-flex justify-content-between">
                            <div>
                                <h1>{title}</h1>
                            </div>
                            <div>
                                <Link tag="a" className="btn btn-success" to="/account/add-funds">Add Funds</Link>
                            </div>
                        </div>

                        <div className="row row-eq-height">

                            <div className="col-lg-8 col-xl-8">

                                <PointsSummary />

                            </div>

                            <div className="col-lg-4 col-xl-4">

                                <div className="card h-100">
                                    <div className="card-body d-flex flex-column">
                                        <div>
                                            <h5 className="card-title">Learn more</h5>
                                            <p>Here is some brief information about the credits. You can learn more by clicking the link below.</p>
                                        </div>
                                        <div>
                                            <a href="/article/points" className="btn btn-primary">Learn more</a>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>

                        <PointsTransactions
                            match={match}
                            history={history}
                        />

                    </div>
                </main>
            </div>
            <Footer />
        </Fragment>
    )
}

export default CreditsAndPoints
